import type { MenuItemProps } from './MenuItem'
import { getMenuItemContentClassNames } from './menu-item-styles'

type MenuItemContentProps = Pick<MenuItemProps, 'disabled' | 'icon' | 'label' | 'selected' | 'subheading' | 'trailingIcon' | 'variant'> & {
  highlighted?: boolean
}

export function MenuItemContent({
  disabled = false,
  highlighted = false,
  icon: Icon,
  label,
  selected = false,
  subheading,
  trailingIcon: TrailingIcon,
  variant = 'primary',
}: MenuItemContentProps) {
  const { iconClassName, labelClassName, subheadingClassName } = getMenuItemContentClassNames({ disabled, highlighted, selected, variant })

  return (
    <>
      {Icon && <Icon className={iconClassName} aria-hidden />}
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-0">
        <span className={labelClassName}>{label}</span>
        {subheading && <span className={subheadingClassName}>{subheading}</span>}
      </div>
      {TrailingIcon && <TrailingIcon className={iconClassName} aria-hidden />}
    </>
  )
}
